import { ReportsModal } from '@/shared/components/reports-modal'
import { FiFile, FiUser } from 'react-icons/fi'
import { useLoaderData } from 'react-router-dom'
import { useRoleSettings } from '@/hooks/use-role-settings'

export const ContractReports = () => {
  const { contractColumns = [], contractSummaryColumns = [] } = useLoaderData()
  const { hasSetting } = useRoleSettings('contract_summary_report')

  const reportOptions = [
    {
      label: 'Tabla de contratos',
      description:
        'Descarga la información general de los contratos visibles en la tabla.',
      value: 'contract',
      icon: FiUser,
      columns: contractColumns
    },
    {
      label: 'Tabla resumen contratos',
      description:
        'Descarga una vista consolidada por contrato con contratista, acreditación, personas activas e inactivas y avances porcentuales de documentos Una vez.',
      value: 'contract_summary',
      icon: FiUser,
      columns: contractSummaryColumns
    },
    {
      label: 'Listado de documentos',
      description:
        'Descarga el listado de documentos asociados a los contratos',
      value: 'contract_attachments',
      icon: FiFile,
      columns: []
    }
  ]

  return (
    <ReportsModal
      reportOptions={reportOptions.filter((reportOption) => {
        if (reportOption.value !== 'contract_summary') return true

        return hasSetting('contract_summary_report')
      })}
    />
  )
}
